import { useState } from 'react';
import { useEvidenceUpload } from '@/api/hooks/useEvidenceUpload';

async function sha256(file: File): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function EvidenceUploader({ taxYear, openItemId, lineItemIds = [] }: { taxYear: number; openItemId?: string; lineItemIds?: string[] }) {
  const upload = useEvidenceUpload();
  const [kind, setKind] = useState('receipt');
  const [error, setError] = useState<string | null>(null);
  return (
    <form onSubmit={async (event) => {
      event.preventDefault();
      setError(null);
      const input = event.currentTarget.elements.namedItem('evidence-file');
      if (!(input instanceof HTMLInputElement) || !input.files?.[0]) { setError('Choose a document to attach.'); return; }
      try {
        const file = input.files[0];
        upload.mutate({ taxYear, file, kind, sha256: await sha256(file), openItemId, lineItemIds });
      } catch { setError('The document could not be checked. Try again.'); }
    }} className="flex flex-col gap-2">
      <label htmlFor="evidence-kind" className="text-sm font-semibold">Evidence type</label>
      <select id="evidence-kind" value={kind} onChange={(event) => setKind(event.target.value)} className="min-h-11 rounded-md border border-input px-3">
        <option value="receipt">Receipt</option>
        <option value="invoice">Invoice</option>
        <option value="1099_k">1099-K</option>
        <option value="1099_nec">1099-NEC</option>
        <option value="mileage_log">Mileage log</option>
        <option value="home_office">Home office</option>
      </select>
      <label htmlFor="evidence-file" className="text-sm font-semibold">Attach a document</label>
      <input id="evidence-file" name="evidence-file" type="file" accept="application/pdf,image/jpeg,image/png" />
      {error && <p role="alert">{error}</p>}
      <button type="submit" disabled={upload.isPending} className="min-h-11 rounded-md bg-foreground px-4 text-sm font-semibold text-background">{upload.isPending ? 'Uploading…' : 'Attach evidence'}</button>
    </form>
  );
}

